var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"page-fixed-bearings"}},[_c('div',{staticClass:"container"},[_c('AppRouterTabNav',{attrs:{"items":_vm.tabsItems}}),_c('div',{staticClass:"contentbox"},[_c('router-view')],1)],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }